import translations from '../../components/location/ts/fr-CA';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('fr-CA', translations);
